import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoginSingupLayout from '../../components/loginSingupLayout';
import {
  Button,
  Input,
  Label,
  Title,
  FormField,
  ErrorMessage,
} from './styles';
import { confirmPasswordReset, ForgotPasswordAppDispatch } from '../../modules/forgotPassword';
import { RootState } from '../../store';
import AlertPopup from '../../components/common/AlertPopup';

const schema = yup.object().shape({
  newPassword: yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
});

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');
  const dispatch = useDispatch<ForgotPasswordAppDispatch>();
  const { isLoading, error, success } = useSelector((state: RootState) => state.forgotPassword);
  const navigate = useNavigate();
  const [alert, setAlert] = useState<{ message: string, severity: 'success' | 'error' } | null>(null);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: any) => {
    if (uid && token) {
      dispatch(confirmPasswordReset({ uid, token, new_password: data.newPassword }));
    }
  };

  useEffect(() => {
    if (success) {
      setAlert({ message: 'Password reset successful', severity: 'success' });
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  }, [success, navigate]);

  useEffect(() => {
    if (error) {
      setAlert({ message: error, severity: 'error' });
    }
  }, [error]);

  return (
    <LoginSingupLayout>
      {alert && <AlertPopup message={alert.message} severity={alert.severity} open={!!alert} onClose={() => setAlert(null)} />}
      <Title>Reset Password</Title>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField>
          <Label htmlFor="newPassword">New Password*</Label>
          <Input {...register('newPassword')} id="newPassword" type="password" placeholder="Enter your new password" />
          {errors.newPassword && <ErrorMessage>{errors.newPassword.message}</ErrorMessage>}
        </FormField>
        <Button type="submit" disabled={isLoading || !uid || !token}>{isLoading ? 'Resetting...' : 'Submit'}</Button>
      </form>
    </LoginSingupLayout>
  );
};

export default ResetPasswordPage;
